import * as types from './actionTypes';
import * as actions from './actions';
import { select, put, all, fork, takeLatest, call } from 'redux-saga/effects';
import * as _ from 'lodash';
import { gettranId, getApiServiceUrlByComponentAndMethod, serviceConsumer } from '../../helpers/helpersIndex';
import { IDisplayToken, IDisplayBoardState } from '../../models/displayboardModel';

const DISPLAYBOARDMODULE = 'QD1';
const displayBoardComponent = 'DisplayBoard';

function* getTokensData(action) {
    let tranId = gettranId(DISPLAYBOARDMODULE);
    console.log(`${tranId}_getTokensData_Start => `, action);

    let displayBoardId: string | undefined;
    let themeName: string | undefined;
    let displayBoardModel = (yield select())['displayBoardReducer'] as IDisplayBoardState;
    let tokensData: IDisplayToken[] | undefined = displayBoardModel.tokensData;
    let differentialTokens: IDisplayToken[] = [];
    let isLicenseActive = displayBoardModel?.isLicenseActive;
    let isDisplayBoardActive = displayBoardModel?.isDisplayBoardActive;

    const { displayId, confirmAction } = action.payload;
    try {
        let displayBoardComponentAndMethod = getApiServiceUrlByComponentAndMethod(displayBoardComponent, 'getDisplayboardInfoWithTokens');

        console.log(`${tranId}_getDisplayboardInfoWithTokens_Api_Request => `, displayBoardComponentAndMethod, displayId);
        let response = yield call(serviceConsumer, tranId, displayBoardComponentAndMethod, { displayBoardId: displayId + '' }, null);
        console.log(`${tranId}_getDisplayboardInfoWithTokens_Api_Response => `, response);

        if (response && response.displayBoardId) {
            displayBoardId = response.displayBoardId;
            themeName = response.themeName;
            isLicenseActive = response.isLicenseActive;
            isDisplayBoardActive = response.displayBoardStatus;

            if (tokensData) {
                differentialTokens = _.differenceWith(response.tokens, tokensData, _.isEqual);
                console.log(`${tranId}_differentialTokens => `, differentialTokens);
            }
            tokensData = response.tokens;

            console.log(`${tranId}_getTokensData_End => `, displayBoardId, themeName, tokensData, differentialTokens, isDisplayBoardActive);
            yield put(actions.setDisplayIdAndGetTokensDataResponse(displayBoardId, themeName, tokensData, differentialTokens, isLicenseActive, isDisplayBoardActive));
        }
        else {
            // navigate to 403
            console.log(`${tranId}_getTokensData_else => `);
            yield put(actions.setDisplayIdAndGetTokensDataResponse('did', '', undefined, [], isLicenseActive, isDisplayBoardActive));
        }
    }
    catch (error) {
        // navigate to 403
        console.log(`${tranId}_getTokensData_catch => `, error);
        yield put(actions.setDisplayIdAndGetTokensDataResponse('did', '', undefined, [], isLicenseActive, isDisplayBoardActive));
    }
}

function* getTokensDataWithSocket(action) {
    let tranId = gettranId(DISPLAYBOARDMODULE);
    console.log(`${tranId}_getTokensDataWithSocket_Start => `, action);

    let response = action.payload;
    let displayBoardId: string | undefined;
    let themeName: string | undefined;
    let displayBoardModel = (yield select())['displayBoardReducer'] as IDisplayBoardState;
    let tokensData: IDisplayToken[] | undefined = displayBoardModel.tokensData;
    let differentialTokens: IDisplayToken[] = [];
    let isLicenseActive = displayBoardModel?.isLicenseActive;
    let isDisplayBoardActive = displayBoardModel?.isDisplayBoardActive;

    try {

        if (response && response.displayBoardId) {
            displayBoardId = response.displayBoardId;
            themeName = response.themeName;
            isLicenseActive = response.isLicenseActive;
            isDisplayBoardActive = response.displayBoardStatus;
            console.log(`${tranId}_getTokensDataWithSocket_tokensData => `, response?.tokens, tokensData);
            if (tokensData) {
                differentialTokens = _.differenceWith(response.tokens, tokensData, _.isEqual);
                console.log(`${tranId}_getTokensDataWithSocket_differentialTokens => `, differentialTokens);
            }
            tokensData = response.tokens;

            console.log(`${tranId}_getTokensDataWithSocket_End => `, displayBoardId, themeName, tokensData, differentialTokens, isLicenseActive, isDisplayBoardActive);
            yield put(actions.setDisplayIdAndGetTokensDataResponse(displayBoardId, themeName, tokensData, differentialTokens, isLicenseActive, isDisplayBoardActive));
        }
        else {
            // navigate to 403
            console.log(`${tranId}_getTokensDataWithSocket_else => `);
            yield put(actions.setDisplayIdAndGetTokensDataResponse('did', '', undefined, [], isLicenseActive, isDisplayBoardActive));
        }
    }
    catch (error) {
        // navigate to 403
        console.log(`${tranId}_getTokensDataWithSocket_catch => `, error);
        yield put(actions.setDisplayIdAndGetTokensDataResponse('did', '', undefined, [], isLicenseActive, isDisplayBoardActive));
    }
}



function* displayBoardWatcher() {
    yield takeLatest(types.SET_DISPLAY_ID_AND_GET_TOKENS_DATA_REQUEST, getTokensData);
    yield takeLatest(types.GET_TOKENS_DATA_WITH_SOCKET_REQUEST, getTokensDataWithSocket);
}

function* displayBoardSaga() {
    yield all([fork(displayBoardWatcher)]);
}
export default displayBoardSaga;